import React from 'react';

import { Button } from 'src/common/components/button/button';

type LoadMoreProps = {
  hasMore: boolean;
  isLoading: boolean;
  onClick: () => void;
};

export const LoadMore = ({ hasMore, isLoading, onClick }: LoadMoreProps) => {
  if (!hasMore || isLoading) {
    return null;
  }

  return (
    <section className="blog__load-more-container">
      <Button className="blog__load-more-btn" onClick={onClick}>
        Load more
      </Button>
    </section>
  );
};
